import { EmptyState } from '@freightapi/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useConsoleI18n } from '../lib/locale'
import { useSession } from '../lib/session'

/** The dashboard shell. The sections it links to are filled by M3-02 up to M3-07. */
export const Route = createFileRoute('/_app/')({ component: Dashboard })

function Dashboard() {
  const { t } = useConsoleI18n()
  const state = useSession()

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-semibold text-display text-ink">{t('dashboard.title')}</h1>
      <p className="text-body text-muted">{t('dashboard.intro')}</p>

      {state.status === 'authenticated' && !state.session.organization.live_enabled ? (
        <EmptyState title={t('live.title')} description={t('live.body')} />
      ) : null}
    </section>
  )
}
